import { SearchResponseDto } from '@/models/Dtos/common/searchResultDto';
import { SearchCandidateDto } from '@/models/Dtos/searchCandidateDto';
import { BaseCandidate } from '@/models/Entities/BaseCandidate';
import { TableDataProvider } from '../../models/TableDataProvider';
import { OTSRosterTableData } from './OTSRosterTableData';

export class OTSRosterDataProvider extends TableDataProvider<
  OTSRosterTableData,
  BaseCandidate,
  SearchCandidateDto
> {
  protected transformer = (t: BaseCandidate): OTSRosterTableData =>
    new OTSRosterTableData(t);

  protected queryHandler = async (
    searchDto: SearchCandidateDto
  ): Promise<SearchResponseDto<BaseCandidate>> => {
    const results: SearchResponseDto<BaseCandidate> = await this.store.dispatch(
      'candidateModule/fetchWithSelectParameters',
      searchDto
    );
    return results;
  };
}
